((Drupal, once) => {
  'use strict';

  Drupal.behaviors.glightboxKaltura = {
    attach(context) {
      // Find each Kaltura embed once, without jQuery.
      const wrappers = once('glightbox-kaltura', '.kaltura-embed', context);
      wrappers.forEach((wrap) => {
        const iframe = wrap.querySelector('iframe.kaltura-embed__frame');
        if (!iframe) return;
        const src = iframe.getAttribute('src');
        if (!src) return;

        //console.log('Kaltura Video: ' + src);

        // Make the inline iframe non-interactive so clicks hit our overlay.
        wrap.style.position = 'relative';
        iframe.setAttribute('tabindex', '-1');
        iframe.setAttribute('aria-hidden', 'true');
        iframe.style.pointerEvents = 'none';

        // Add an accessible, full-area overlay button.
        const overlay = document.createElement('a');
        overlay.className = 'kaltura-overlay stretched-link glightbox';
        overlay.setAttribute('href', src);
        overlay.setAttribute('data-glightbox', 'width: 1400; height: 790');
        overlay.setAttribute('aria-label', 'Play video in a modal');
        wrap.appendChild(overlay);

      });
    }
  };
})(Drupal, once);
